import { i18next } from '@frontend/i18n';
import { formatTime } from '../../utils/get-event-accordion-body';
import { EventRenderer } from '../../utils/render-event';
import { AccordionEvent } from '../../utils/render-event-accordion';
import { EventBox } from '../event-renderer-item';

export const renderVoicemailPrompt: EventRenderer = (event, { callerName }) => {
  if (!('voicemailPromptEvent' in event)) return null;

  const { createdAt } = event;
  const { voicemailBoxId, voicemailBoxName, transcription } = event.voicemailPromptEvent;
  const createdAtTime = formatTime(createdAt);

  const content = (
    <EventBox
      key={voicemailBoxId}
      iconName='voicemail'
      title={i18next.t('Voicemail', { ns: 'calls' })}
      subtitle={voicemailBoxName}
      endAdornment={createdAtTime}
      hideBoxShadow={!!transcription}
    />
  );

  if (!!transcription) {
    return (
      <AccordionEvent event={event} eventKey={`voicemail-prompt-${voicemailBoxId}`} callerName={callerName}>
        {content}
      </AccordionEvent>
    );
  }

  return content;
};
